export const PageHeader = ({ title, subtitle, right }) => (
  <header className="sticky top-0 z-30 flex items-center justify-between border-b border-[#12142b]/8 bg-white/85 px-8 py-4 backdrop-blur">
    <div>
      <h1 className="font-display text-2xl font-extrabold tracking-tight text-[#12142b]">{title}</h1>
      {subtitle && <p className="text-sm text-[#565b73]">{subtitle}</p>}
    </div>
    {right}
  </header>
);

export const StatusBadge = ({ status }) => {
  const map = {
    active: ["#16a34a", "#16a34a14"],
    completed: ["#16a34a", "#16a34a14"],
    approved: ["#16a34a", "#16a34a14"],
    resolved: ["#16a34a", "#16a34a14"],
    pending: ["#f59e0b", "#f59e0b14"],
    open: ["#2340b5", "#2340b514"],
    suspended: ["#e4002b", "#e4002b14"],
  };
  const [c, bg] = map[status] || ["#565b73", "#565b7314"];
  return (
    <span className="rounded-full px-2.5 py-1 text-xs font-semibold capitalize" style={{ color: c, backgroundColor: bg }}>
      {status}
    </span>
  );
};

export const Pagination = ({ page, pages, onPage }) => (
  <div className="mt-4 flex items-center justify-between text-sm text-[#565b73]">
    <span>Page {page} of {pages}</span>
    <div className="flex gap-2">
      <button
        disabled={page <= 1}
        onClick={() => onPage(page - 1)}
        className="rounded-lg border border-[#12142b]/10 px-3 py-1.5 font-medium disabled:opacity-40"
      >
        Previous
      </button>
      <button
        disabled={page >= pages}
        onClick={() => onPage(page + 1)}
        className="rounded-lg border border-[#12142b]/10 px-3 py-1.5 font-medium disabled:opacity-40"
      >
        Next
      </button>
    </div>
  </div>
);
